import React from 'react';
import { useQuery } from "@tanstack/react-query";
import Loading from '../Loading';
import { useNavigate } from 'react-router-dom';
import { getTransactions } from '../../services/data';

const StatusList = ({ data }) => {
    const tableStyle = {
      width: '100%',
      borderCollapse: 'collapse',
      boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
      marginTop: '1rem',
    };
  
    const thTdStyle = {
      border: '1px solid #ccc',
      padding: '8px',
      textAlign: 'left',
    };
  
    const headerStyle = {
    };
  
    if (!Array.isArray(data) || data.length === 0) {
      return <div>No data available.</div>;
    }
  
    return (
      <div>
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={{ ...thTdStyle, ...headerStyle }}>Status</th>
              <th style={{ ...thTdStyle, ...headerStyle }}>Count</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => {
              const status = item?.status ?? 'N/A';
              const count = item?.['count(status)'] ?? 'N/A';
              return (
                <tr key={index}>
                  <td style={thTdStyle}>{status}</td>
                  <td style={thTdStyle}>{count}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };
  

export default function Transactions() {
    const navigate = useNavigate();

    const {
        data: additionalData,
        status: additionalDataStatus,
        isLoading: additionalDataLoading,
        error: additionalDataError,
    } = useQuery({
        queryKey: ['transactions'],
        queryFn: () => getTransactions(),
    });



    if (additionalDataLoading) return <Loading />
    if (additionalDataError) {
        navigate('/login')
    }

    return (
        <div>
            {additionalDataError && (<h1>Failed to fetch user table</h1>)}
            {(!additionalDataLoading && additionalDataStatus === 'success') && <div>
            Today's razorpay transactions
                <StatusList data={additionalData}/>
            </div>}
        </div>

    )
}
